//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.LaserCutDirection.js";
import "../CAM/CAM.LaserHeadOrientation.js";
import "../CAM/CAM.LaserControlPointList.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[0,"CollisionCheck",1,0],[1,"CutDirection",0,"CAM.LaserCutDirection",0],[1,"HeadOrientation",0,"CAM.LaserHeadOrientation",0],[0,"InterpMethod",1,0],[1,"List",0,"CAM.LaserControlPointList",0],[0,"MaxGapDist",1,0],[0,"MaxTiltAngle",1,0],[0,"ProfileSection",1,"Section",0],[0,"ShapeType",1,0],[0,"ToolSide",1,0]],[[["headOrientType","pointTag","csysTag","processType","toggle","udePathTag","pointType"],"CreateControlPoint",{R_:{controlPoint:"CAM.LaserControlPoint"}},7,0]],[]];
SPLM.CAM.LaserProfileMove = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.LaserProfileMove";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.LaserProfileMove.ShapeTypes = Object.freeze({
    "ExternalTrim" : "ExternalTrim", "InternalTrim" : "InternalTrim", "OpenProfile" : "OpenProfile"});

SPLM.CAM.LaserProfileMove.ToolSides = Object.freeze({
    "On" : "On", "Left" : "Left", "Right" : "Right"});

SPLM.CAM.LaserProfileMove.CollisionChecks = Object.freeze({
    "None" : "None", "NozzleOnly" : "NozzleOnly", "NozzleAndHolder" : "NozzleAndHolder", "SolidLaserHead" : "SolidLaserHead"});

SPLM.CAM.LaserProfileMove.InterpMethods = Object.freeze({
    "Linear" : "Linear", "CubicSpline" : "CubicSpline", "Smooth" : "Smooth"});

export default SPLM;